export const icons = [
  'arrow',
  'arrow-down',
  'arrow-left',
  'arrow-right',
  'background',
  'badge-01',
  'badge-02',
  'badge-03',
  'badge-04',
  'banner-circle',
  'close',
  'facebook-solid',
  'facebook',
  'hamburger',
  'icon-download',
  'icon-draw-3-files',
  'icon-draw-anonymous',
  'icon-draw-app',
  'icon-draw-auth',
  'icon-draw-bill',
  'icon-draw-binders',
  'icon-draw-box',
  'icon-draw-calc',
  'icon-draw-car',
  'icon-draw-cart',
  'icon-draw-certificate',
  'icon-draw-chat',
  'icon-draw-circle-start',
  'icon-draw-client',
  'icon-draw-collab',
  'icon-draw-connecting-users',
  'icon-draw-contract',
  'icon-draw-convert-currency',
  'icon-draw-door',
  'icon-draw-entrance',
  'icon-draw-envelop',
  'icon-draw-error',
  'icon-draw-euro-card',
  'icon-draw-find',
  'icon-draw-folder-female',
  'icon-draw-group',
  'icon-draw-hospital',
  'icon-draw-information-booklet',
  'icon-draw-letter',
  'icon-draw-mail-box',
  'icon-draw-name-plate-female',
  'icon-draw-note',
  'icon-draw-office-2',
  'icon-draw-office',
  'icon-draw-phone',
  'icon-draw-portal',
  'icon-draw-press',
  'icon-draw-privacy',
  'icon-draw-profile-lightbulb',
  'icon-draw-question',
  'icon-draw-read',
  'icon-draw-secret',
  'icon-draw-security',
  'icon-draw-send',
  'icon-draw-settings',
  'icon-draw-share-file-1',
  'icon-draw-share-file-2',
  'icon-draw-share-with-group',
  'icon-draw-target-group',
  'icon-draw-targeted-head',
  'icon-draw-toddler',
  'icon-draw-user-flowchart',
  'icon-draw-wheel-chair',
  'icon-draw-writing-group',
  'linkedin-solid',
  'linkedin',
  'logo-solid',
  'logo',
  'mail',
  'search',
  'share',
  'stripes',
  'trash',
  'twitter-solid',
  'twitter',
  'whatsapp',
  'youtube-solid',
] as const;

export type Icon = (typeof icons)[number];

export function isIcon(value: string): value is Icon {
  return icons.includes(value as Icon);
}
